import React from 'react';
import { autocompletePlacesPath } from '../../../utilities/api_relative_paths';
import Autocomplete from './autocomplete';
import { ConfigurationProps } from './types';

const PlacesAutocomplete = (props: ConfigurationProps) => {
  const config = {
    placeholder: 'Select location',
    id: 'placesAutocomplete',
    apiPath: autocompletePlacesPath,
    ...props,
  };

  return (
    <Autocomplete {...config}/>
  );
};

export default PlacesAutocomplete;
